import { render, staticRenderFns } from "./Consume.vue?vue&type=template&id=48a1be62&lang=pug&"
import script from "./Consume.vue?vue&type=script&lang=js&"
export * from "./Consume.vue?vue&type=script&lang=js&"
import style0 from "./Consume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports